module.exports = __webpack_public_path__ + "static/media/BusinessName-es.b293ba10.jpg";